import { QuickSelectTokenStore } from "@/domains/tokens/quick-select-token-store"
import { ETH, frxUSD, SCALE, USDC, WETH } from "@/domains/tokens/static-tokens"

/**
 * Factory to create QuickSelectTokenStore populated with static tokens.
 *
 * Uses static token exports directly - no repository needed.
 * Static tokens are TokenStore instances that are the same objects
 * added to the repository, so prices/balances updates are automatically reflected.
 *
 * Order: SCALE, ETH, WETH, frxUSD, USDC (5 tokens to fit layout)
 */
export class QuickSelectTokenStoreFactory {
  static create(): QuickSelectTokenStore {
    const quickSelectTokens = [SCALE, ETH, WETH, frxUSD, USDC]

    return new QuickSelectTokenStore(quickSelectTokens)
  }
}
